export default __webpack_public_path__ + "static/trend-experiment-calculation-dark-bdacdab670bf76592d45b733a9afc51e.png";